import { ApolloError } from '@apollo/client';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Used to handle Apollo GraphQL errors
 * e.g. user does not have access to a particular resource
 *
 */
const useOnError = () => {
  const navigate = useNavigate();

  const onError = useCallback(
    ({ graphQLErrors }: ApolloError) => {
      for (let err of graphQLErrors) {
        switch (err.extensions?.code) {
          case 'FORBIDDEN':
            navigate('/not-found', { replace: true });
            break;
          default:
            return;
        }
      }
    },
    [navigate],
  );

  return { onError };
};

export default useOnError;
